import React, { useCallback, useMemo, useRef, useState } from 'react'
import { postInfo } from './backend'
import { ChatMessage } from '@market-up/chat-core'
import dayjs from 'dayjs'

export const isEmptyObject = (obj: {}): boolean => {
  return Object.keys(obj).length === 0
}

const supportsNotification = 'Notification' in window
export const requestNotificationPermission = () => {
  if (supportsNotification && Notification.permission !== 'granted') {
    Notification.requestPermission()
  }
}
export const newMessageNotification = (options: { title: string, icon: string }, onClick: () => void): void => {
  if (supportsNotification) {
    const { title, icon } = options
    const notification = new Notification(title, { icon })
    notification.onclick = onClick
  }
}

export const openLink = (url: string, domId: string) => {
  let a = document.createElement('a')
  a.setAttribute('href', url)
  a.setAttribute('target', '_self')
  a.setAttribute('id', domId)
  const openDom = document.getElementById(domId) as HTMLElement
  if (openDom) {
    document.body.removeChild(openDom)
  }
  document.body.appendChild(a)
  a.click()
}

export const trackChatPage = (serviceClassifyId?: number): void => {
  const params = new URLSearchParams(window.location.search)
  const title = params.get('pageTitle')
  const url = params.get('pageUrl')
  if (title && url) {
    const page = {
      title: params.get('pageTitle'),
      url: decodeURIComponent(url),
      serviceClassifyId
    }
    postInfo(page, 'SYS_METADATA')
  }
}
export const getUserId = () => {
  const params = new URLSearchParams(window.location.search)
  return params.get('userId') ?? undefined
}

export const useUserId = () => {
  return useMemo(() => getUserId(), [])
}

interface TaggedMessage extends ChatMessage {
  dayjs: dayjs.Dayjs
}

export const groupMessagesByDay = (messages: ChatMessage[]): TaggedMessage[][] => {
  const taggedAndSortedMessages = messages
    .map(message => ({
      ...message,
      dayjs: dayjs(message.sendTime)
    }))
    .sort((a, b) => a.dayjs.isBefore(b.dayjs) ? -1 : 1)
  const groupedByDay: TaggedMessage[][] = []
  for (const message of taggedAndSortedMessages) {
    const last = groupedByDay[groupedByDay.length - 1]?.[0]
    if (last) {
      if (last.dayjs.isSame(message.dayjs, 'day')) {
        groupedByDay[groupedByDay.length - 1].push(message)
      } else {
        groupedByDay.push([message])
      }
    } else {
      groupedByDay.push([message])
    }
  }
  return groupedByDay
}

export const useForceUpdate = () => {
  const whatever = useRef(false)
  const [, set] = useState(false)
  return useCallback(() => {
    whatever.current = !whatever.current
    set(whatever.current)
  }, [set])
}

export const useDomainUtmSource = (domain: string) => {
  const params = new URLSearchParams(window.location.search)
  params.append('utm_source', 'flotaingbar')
  const search = params.toString() ? `?${params.toString()}` : ''
  return `${domain}${search}`
}

export const messageQueue: string[] = []
